import { v4 as uuidv4 } from "uuid";
import { ASSISTANT_PROMPTS_TYPES } from "../actions/assistantPrompts-actions";

const MAX_ITEMS = 10;

const initialState = {
  recents: [],
  favorites: [],
  previousFavorites: [],
  isPanelOpen: false,
  activeTab: "recents",
  pendingText: null,
  lastToggleAction: null,
  patchStatus: {
    isLoading: false,
    hasError: false,
    errorMessage: "",
    statusCode: 0,
  },
};

const assistantPromptsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ASSISTANT_PROMPTS_TYPES.TOGGLE_PANEL:
      return { ...state, isPanelOpen: !state.isPanelOpen };

    case ASSISTANT_PROMPTS_TYPES.SET_ACTIVE_TAB:
      return { ...state, activeTab: action.payload };

    case ASSISTANT_PROMPTS_TYPES.ADD_RECENT: {
      const text = action.payload;
      if (state.recents[0]?.text === text) return state;
      const updated = [{ id: uuidv4(), text, timestamp: Date.now() }, ...state.recents];
      return { ...state, recents: updated.slice(0, MAX_ITEMS) };
    }

    case ASSISTANT_PROMPTS_TYPES.SET_FAVORITES: {
      const items = Object.entries(action.payload || {})
        .sort(([a], [b]) => Number(a) - Number(b))
        .map(([id, text]) => ({ id, text }));
      return { ...state, favorites: items };
    }

    case ASSISTANT_PROMPTS_TYPES.TOGGLE_FAVORITE: {
      const text = action.payload;
      const previousFavorites = [...state.favorites];
      const existing = state.favorites.findIndex((f) => f.text === text);
      const isRemoving = existing !== -1;
      let favorites;
      if (isRemoving) {
        favorites = state.favorites.filter((_, i) => i !== existing);
      } else {
        const newEntry = { id: String(Date.now()), text };
        favorites =
          state.favorites.length < MAX_ITEMS
            ? [...state.favorites, newEntry]
            : [...state.favorites.slice(1), newEntry];
      }
      return {
        ...state,
        previousFavorites,
        favorites,
        pendingText: text,
        lastToggleAction: isRemoving ? "remove" : "add",
        patchStatus: { isLoading: true, hasError: false, errorMessage: "", statusCode: 0 },
      };
    }

    case ASSISTANT_PROMPTS_TYPES.PATCH_REQUEST:
      return {
        ...state,
        patchStatus: { isLoading: true, hasError: false, errorMessage: "", statusCode: 0 },
      };

    case ASSISTANT_PROMPTS_TYPES.PATCH_SUCCESS:
      return {
        ...state,
        previousFavorites: [],
        pendingText: null,
        patchStatus: {
          isLoading: false,
          hasError: false,
          errorMessage: "",
          statusCode: action.payload?.status || 200,
        },
      };

    case ASSISTANT_PROMPTS_TYPES.PATCH_FAILURE:
      return {
        ...state,
        favorites: state.previousFavorites,
        previousFavorites: [],
        pendingText: null,
        patchStatus: {
          isLoading: false,
          hasError: true,
          errorMessage: action.payload || "Failed to save",
          statusCode: 0,
        },
      };

    default:
      return state;
  }
};

export default assistantPromptsReducer;
